(() => {
  const MOBILE_HEIGHT = 190;
  const DESKTOP_HEIGHT = 320;
  const BREAKPOINT = 750;

  function getCollapsedHeight() {
    return window.innerWidth < BREAKPOINT ? MOBILE_HEIGHT : DESKTOP_HEIGHT;
  }

  function setupReadMore(wrap) {
    if (wrap.dataset.readMoreInit === "true") return;

    const inner = wrap.querySelector(".product__description-inner");
    const btn = wrap.querySelector(".product__description-toggle");

    if (!inner || !btn) return;

    wrap.dataset.readMoreInit = "true";

    const collapse = (scrollBack = false) => {
      const height = getCollapsedHeight();

      wrap.classList.remove("is-expanded");
      inner.style.maxHeight = `${height}px`;
      inner.style.overflow = "hidden";

      btn.textContent = "Lasīt vairāk";
      btn.setAttribute("aria-expanded", "false");

      if (scrollBack) {
        wrap.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    };

    const expand = () => {
      wrap.classList.add("is-expanded");

      inner.style.maxHeight = "none";
      inner.style.overflow = "visible";

      btn.textContent = "Rādīt mazāk";
      btn.setAttribute("aria-expanded", "true");
    };

    const refresh = () => {
      const height = getCollapsedHeight();

      /*
       * Temporarily remove max-height so we can measure
       * the real description height.
       */
      const wasExpanded = wrap.classList.contains("is-expanded");

      inner.style.maxHeight = "none";
      inner.style.overflow = "visible";

      const fullHeight = inner.scrollHeight;

      if (fullHeight <= height + 10) {
        btn.hidden = true;
        wrap.classList.add("is-short");
        return;
      }

      btn.hidden = false;
      wrap.classList.remove("is-short");

      if (wasExpanded) {
        expand();
      } else {
        collapse(false);
      }
    };

    collapse(false);

    btn.addEventListener(
      "click",
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (wrap.classList.contains("is-expanded")) {
          collapse(true);
        } else {
          expand();
        }
      },
      true
    );

    refresh();
  }

  function initReadMore() {
    document
      .querySelectorAll(".product__description[data-read-more]")
      .forEach(setupReadMore);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReadMore);
  } else {
    initReadMore();
  }

  window.addEventListener("load", initReadMore);
  document.addEventListener("shopify:section:load", initReadMore);
  document.addEventListener("variant:change", initReadMore);
})();